import { DATABASES } from "../core/database/datasources";
import { updateSmsStatus } from "./event-detail";

const updateDb = async (payload, app, table) => {
    //console.debug(`[WS] Update database for table ${table}`, payload);
    const database = app.getDatabase(DATABASES.eventDb);
    if (!database) {
        console.error(`[WS] Database not found: ${DATABASES.eventDb}`);
        return;
    }
    const db = database[table];
    if (!db) {
        console.error(`[WS] Store not found: ${table}`);
        return;
    }

    if (payload.deleted) {
        await db.delete(payload.id);
        return;
    }

    const key = payload.id;
    // On ne fait pas de comparaison ici pour permettre la synchronisation inter-onglets.
    // IndexedDB étant partagée, si un autre onglet a déjà mis à jour la base, 
    // l'appel à db.put() permet de déclencher l'événement 'updated' localement.
    console.log('Storing payload in database:');
    await db.put(payload);
};

export const WS_CALLBACK = {
    EVENT_UPDATE: (payload, app) => updateDb(payload, app, 'event'),
    MESSAGE_UPDATE: async (payload, app) => {
        await updateDb(payload, app, 'sms');
        updateSmsStatus(payload);
    },
    EVENT_DETAILS_UPDATE: (payload, app) => updateDb(payload, app, 'detailed_event'),
    HELICOPTER_UPDATE: (payload, app) => updateDb(payload, app, 'helicopter')
};